import HoverVideoPlayer from 'react-hover-video-player';

import useTranslation from '../../features/translation/hooks/useTranslation';
import useResources from './hooks/useResources';

import './Graphic.scss';
import PlayButton from './PlayButton';
import { useState } from 'react';
import { useWindowDimensions } from 'festo-react-ui-kit/lib/utils/utils';

enum TranslationKeys {
  EXAMPLE_APPLICATION = 'exampleApplication',
}

const getXAxis = (width: number): number => {
  let x = -75;
  if (width >= 1920) x = -65;
  else if (width < 1920 && width > 1700) x = -70;
  else if (width < 1700 && width > 1440) x = -60;
  else if (width <= 1440 && width >= 1100) x = -55;
  else if (width < 1100 && width >= 1024) x = -50;
  else if (width < 1023 && width > 850) x = -70;
  else if (width < 850 && width >= 768) x = -60;
  else if (width <= 767 && width > 690) x = -120;
  else if (width <= 690 && width > 572) x = -90;
  else if (width <= 572 && width > 432) x = -70;
  else x = -55;

  return x;
};

export default function Graphic(): JSX.Element {
  const t = useTranslation();
  const resource = useResources();
  const [isOnHover, setIsOnHover] = useState<boolean>(false);
  const { width } = useWindowDimensions();

  const xAxis = getXAxis(width);

  return (
    <div className="ems-graphic">
      <h3 className="fr-heading ems-graphic__headline">{t(TranslationKeys.EXAMPLE_APPLICATION)}</h3>
      <HoverVideoPlayer
        onHoverStart={() => setIsOnHover(true)}
        onHoverEnd={() => setIsOnHover(false)}
        videoSrc={resource.src}
        loop={true}
        overlayTransitionDuration={500}
        restartOnPaused
        pausedOverlay={<img className="ems-graphic__img-cover" src={resource.cover_img} alt={resource.description} />}
      />
      <PlayButton xAxis={xAxis} transparency={isOnHover ? 0 : 0.5} />
    </div>
  );
}
